'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaExtraServicesController = function () {
  function WinresOmalomaExtraServicesController($rootScope, $scope, omalomaService, $q) {
    _classCallCheck(this, WinresOmalomaExtraServicesController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.omalomaService = omalomaService;

    this.$scope.cartExpanded = false;
    this.$scope.cartAlreadyAutoExpandedOnce = false;

    this.$scope._ = _;

    this.$q = $q;

    this.clear();

    // Use a set status function and ngSwitch to control front en status when booking extra services
    // For example show a message  when booking is pending
    this.setExtraServicesBookingStatus('init', null);

    this.dates = null;
  }

  _createClass(WinresOmalomaExtraServicesController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$on('login', function () {
        return _this.load();
      });
      this.$rootScope.$on('logout', function () {
        return _this.clear();
      });
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.load();
      }
      this.$scope.$watch(function () {
        return _this.bookingNumber;
      }, function () {
        return _this.load();
      });

      this.$scope.$watchGroup([function () {
        return _this.$scope.extraServiceLines;
      }, function () {
        return _this.$scope.areaServiceLines;
      }], function () {
        return _this.onProductLinesChange();
      }, true);
    }

    // Initialize / disable the component, due to e.g. user logout.

  }, {
    key: 'clear',
    value: function clear() {
      this.$scope.passengers = null;
      this.$scope.extraServiceLines = null;
      this.$scope.areaServiceLines = null;
      this.$scope.productLines = null;
      this.$scope.loading = false;
      this.$scope.error = null;
      this.$scope.bookingConditionsURL = '#';
      this.conditionsAccepted = false;
      this.$scope.reservable = null;
      this.$scope.areaServices = null;

      // A map of product data for relevant products. Relevant products are:
      // - Previously reserved products
      // - Reservable products
      // The map is organized by destination code and product code.
      this.$scope.relevantProducts = null;
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      this.clear();
      this.$scope.bookingInProcess = false;

      if (!this.bookingNumber) return;
      this.$scope.loading = true;

      this.$scope.relevantProducts = {};

      this.omalomaService.getCustomerReservableExtraServices(this.bookingNumber).then(function (result) {
        console.log('[WOES] Received extra services.', result);
        _this2.setExtraServicesBookingStatus('waiting', null);
        _this2.getBookingConditions(_this2.omalomaService.connectionNameIfLoggedIn());
        _this2.update(result);
      }, function (error) {
        console.error('[WOES] Failed to receive extra services.', error);
        _this2.clear();
        _this2.$scope.error = 'malfunction';
        _this2.setExtraServicesBookingStatus('error', null);
      });

      this.checkClosingDate();
      this.checkPackageProducts();
      this.checkBookingInProcess();

      this.$scope.dates = null;

      this.omalomaService.getBookingMaxDates(this.bookingNumber).then(function (dates) {
        _this2.$scope.dates = dates;
        _this2.getCustomerReservableAreaServices(dates);
      });
    }
  }, {
    key: 'checkClosingDate',
    value: function checkClosingDate() {
      var _this3 = this;

      this.omalomaService.getCustomerReservableExtraServices(this.bookingNumber).then(function (result) {
        _this3.$scope.bookingPastClosingDate = result.ReservableExtraServices.length === 0 || result.ReservableExtraServices[0].ReservabilityCheckResults.BookingDepartureClosingDate;
      });
    }
  }, {
    key: 'checkPackageProducts',
    value: function checkPackageProducts() {
      var _this4 = this;

      this.omalomaService.getProductLines(this.bookingNumber).then(function (products) {
        _this4.$scope.hasPackageProduct = _.some(products, function (product) {
          return product.DestinationInfo.DestinationClass == "Package";
        });
      });
    }
  }, {
    key: 'getCustomerReservableAreaServices',
    value: function getCustomerReservableAreaServices(dates) {
      var _this5 = this;

      //this.clear();
      if (!this.bookingNumber) return;
      this.$scope.loading = true;

      var beginDate = dates.BeginDate;
      var endDate = dates.EndDate;

      this.omalomaService.getCustomerReservableAreaServices(this.bookingNumber, beginDate, endDate).then(function (result) {
        var areaServices = {};
        _.each(result.Lookups.AreaServices, function (areaService) {
          areaServices[areaService.TimeStamp] = areaService.Services;
        });

        _.assign(_this5.$scope.relevantProducts, result.Lookups.RelevantProducts);

        var pickAreaServices = {};
        _.each(areaServices, function (services, timeStamp) {
          pickAreaServices[timeStamp] = services.map(function (s) {
            s.timeStamp = timeStamp;
            var key = [moment(s.BeginDate).format('YYYYMMDD'), s.DestinationInfo.DestinationCode, s.DestinationInfo.ProductCode];
            var existingLines = _.get(result.Lookups.AreaServiceProductLines, key, []);
            return processReservableService(s, existingLines, 0);
          });
        });

        _this5.$scope.areaServices = pickAreaServices;
        _this5.$scope.loading = false;
      });
    }
  }, {
    key: 'update',
    value: function update(data) {
      var _this6 = this;

      this.$scope.loading = false;

      this.$scope.passengers = data.Passengers;
      console.log('[WOES] Updated passengers.', this.$scope.passengers);

      var timeStamp = "0000000000";
      _.assign(this.$scope.relevantProducts, _defineProperty({}, timeStamp, data.Lookups.RelevantProducts));

      this.$scope.reservable = _.map(data.ReservableExtraServices, function (s) {
        s.timeStamp = timeStamp;
        var key = [s.DestinationInfo.DestinationCode, s.DestinationInfo.ProductCode];
        var existingLines = _.get(data.Lookups.ExtraServiceProductLines, key, []);
        return processReservableService(s, existingLines, _this6.$scope.passengers.length);
      });

      // Filter hidden extra services off.
      this.$scope.reservable = _.filter(this.$scope.reservable, function (reservable) {
        if (reservable.data.LinkingInfo.ForcingMode == "Hidden") return false;
        return true;
      });

      console.log('[WOES] Updated reservable.', this.$scope.reservable);
    }
  }, {
    key: 'onExtraServicesChange',
    value: function onExtraServicesChange(lines) {
      this.$scope.extraServiceLines = lines;
    }
  }, {
    key: 'onAreaServicesChange',
    value: function onAreaServicesChange(lines) {
      this.$scope.areaServiceLines = lines;
    }
  }, {
    key: 'onProductLinesChange',
    value: function onProductLinesChange() {
      this.$scope.productLines = _.concat(this.$scope.extraServiceLines, this.$scope.areaServiceLines);

      // Remove nulls.
      this.$scope.productLines = _.compact(this.$scope.productLines);

      console.log('[WOES] Product lines changed.', this.$scope.productLines);
      if (this.$scope.productLines.length !== 0) {
        this.openCartfirstTime();
      }
    }
  }, {
    key: 'cartChange',
    value: function cartChange() {
      console.log('[WOES] Product lines changed.', this.$scope.productLines);
      this.load();
    }
  }, {
    key: 'answerExtraQuestions',
    value: function answerExtraQuestions() {
      this.$rootScope.$broadcast('okclickextraquestions', false);
    }
  }, {
    key: 'cancelExtraQuestions',
    value: function cancelExtraQuestions() {
      this.$rootScope.$broadcast('okclickextraquestions', true);
    }
  }, {
    key: 'validateExtraQuestions',
    value: function validateExtraQuestions() {
      var productLines = this.$scope.productLines || [];
      this.$scope.validExtraQuestionAnswers = _.every(productLines, function (productLine) {
        return _.every(productLine.ExtraQuestions, function (extraQuestion) {
          return extraQuestion.Question && extraQuestion.Answer;
        });
      });
    }
  }, {
    key: 'book',
    value: function book() {
      var _this7 = this;

      var bookingNumber = this.bookingNumber;
      var productLines = this.$scope.productLines || [];
      if (productLines.length === 0) {
        //alert('Ei uusia tuoterivejä.');
        this.setExtraServicesBookingStatus('nonewlines', null);
        return;
      }

      this.$q(function (resolve) {
        // Answer extra questions, then continue with book
        _this7.handleExtraQuestions(productLines, resolve);
      }).then(function (result) {
        if (result === 'ok') {
          _this7.setExtraServicesBookingStatus('bookingnow', null);

          _this7.omalomaService.bookCustomerExtraServices(bookingNumber, productLines).then(function (result) {
            if (result.Status !== 'Success') {
              throw result;
            }
            console.log('[WOES] Booked extra services.', result);
            //alert('Varattiin ' + productLines.length + ' tuoteriviä.');
            _this7.setExtraServicesBookingStatus('bookingsuccess', null);
            //this.load();
          }).catch(function (error) {
            console.error('[WOES] Failed to book extra services.', error);
            //alert('Varaus epäonnistui.\n\n' + JSON.stringify(error));
            _this7.setExtraServicesBookingStatus('bookingerror', JSON.stringify(error));
          });
        } else {
          // Canceled
          _this7.setExtraServicesBookingStatus('waiting', null);
        }
      });
    }
  }, {
    key: 'handleExtraQuestions',
    value: function handleExtraQuestions(productLines, resolve) {
      if (_.some(productLines, function (productLine) {
        return productLine.ExtraQuestions && productLine.ExtraQuestions.length > 0;
      })) {
        _.each(productLines, function (productLine) {
          _.each(productLine.ExtraQuestions, function (extraQuestion) {
            extraQuestion.Answer = '';
          });
        });

        this.validateExtraQuestions();

        this.setExtraServicesBookingStatus('askextraquestions', null);
        var deregisterExtraQuestionOk = this.$scope.$on('okclickextraquestions', function (e, cancel) {
          deregisterExtraQuestionOk();
          if (cancel) {
            resolve('cancel');
          } else {
            resolve('ok');
          }
        });
      } else {
        // No extra questions
        resolve('ok');
      }
    }

    // Open cart the first time when putting in products

  }, {
    key: 'openCartfirstTime',
    value: function openCartfirstTime() {
      if (!this.$scope.cartAlreadyAutoExpandedOnce) {
        console.log("Cart has not yet auto expanded once, expanding cart...");
        this.$scope.cartExpanded = true;
        this.$scope.cartAlreadyAutoExpandedOnce = true;
        console.log("Cart has now auto expanded once and should not open any more");
      }if (this.$scope.cartAlreadyAutoExpandedOnce) {
        console.log("Cart has already auto expanded once");
        return;
      } else {
        console.error("We should see this. Cart auto expand has some issue.");
      }
    }
  }, {
    key: 'setExtraServicesBookingStatus',
    value: function setExtraServicesBookingStatus(status, error) {
      this.$scope.extraServicesBookingStatus = status;
      console.log('Extra services status set  to', status);
      if (error !== undefined) {
        if (error) console.error('Extra services status ERROR: ', error);
        this.$scope.error = error;
      }
    }
  }, {
    key: 'resetExtraservicesBooking',
    value: function resetExtraservicesBooking() {
      this.setExtraServicesBookingStatus('waiting', null);
      this.load();
      this.omalomaService.triggerRefresh(); // Refresh summary and payment.
    }
  }, {
    key: 'getBookingConditions',
    value: function getBookingConditions(connectionName) {
      var _this8 = this;

      if (!connectionName) {
        console.error("[WOES] Failed to get booking conditions. No connection name.");
      } else {
        console.log('[WOES] Getting site office parameters...  connection name is', connectionName);
        this.omalomaService.getOfficeSiteParameters(connectionName).then(function (params) {
          console.log("[WOES] Got Office parameters, response: ", params);
          _this8.$scope.bookingConditionsURL = params.Office.BookingConditionsFi;
          _this8.$scope.phone = params.Office.PhoneNumber;
          _this8.$scope.email = params.Office.EmailAddress;
        }).catch(function (error) {
          console.error('[WOES] Failed to get parameters:', error);
          if (error) {
            console.error("[WOES]  Connection Name not ok");
            _this8.setConnectionStatusFalse();
          }
        });
      }
    }
  }, {
    key: 'checkBookingInProcess',
    value: function checkBookingInProcess() {
      var _this9 = this;

      this.omalomaService.getCustomerBookingBalance(this.bookingNumber).then(function (balance) {
        // Booking invoices total price does not match with booking total price.
        // Prevent extra services booking. 
        _this9.$scope.bookingInProcess = balance.Error === 'InvalidTotal';
      });
    }
  }]);

  return WinresOmalomaExtraServicesController;
}();

function processReservableService(service, existingLines, passengerCount) {
  console.log("[WOES] Extra Services to process: ", service);
  var options = getSelectOptions(service, existingLines, passengerCount);

  var di = service.DestinationInfo;
  var producer = service.Producer;
  if (!producer) {
    console.warn('[WOES] Producer is', producer, 'for', di.DestinationCode, di.ProductCode);
  }
  var serviceImage = (0, _utils.findImage)(service);

  return {
    name: di.ProductName,
    options: options,
    value: options ? options.initial : null, // Options is null if service.LinkingInfo.ForcingMode !== 'Normal'
    data: service,
    image: serviceImage,
    description: producer ? producer.Note3 : di.Headline, // Producer may be null in KV
    code: di.ProductCode,
    price: service.Price,
    IsReservableWithCurrentCriteria: service.IsReservableWithCurrentCriteria,
    DefaultIsReservableWithCurrentCriteria: service.IsReservableWithCurrentCriteria,
    ReservabilityCheckResults: service.ReservabilityCheckResults,
    isTallink: service.IsTallink,
    timeStamp: service.timeStamp
  };
}

function getSelectOptions(service, existingLines, passengerCount) {
  if (service.LinkingInfo && service.LinkingInfo.ForcingMode !== 'Normal') {
    // Can't deal with these
    return null;
  }

  if (service.IsMultiReservable) {
    return selectPrices(service, existingLines);
  } else if (service.LinkingInfo && service.LinkingInfo.IsForEachPassenger) {
    return selectPassengers(service, existingLines, passengerCount);
  } else {
    return selectAmount(service, existingLines);
  }
}

function selectAmount(service, existingLines) {
  var old = _.sumBy(existingLines, function (line) {
    return line.Capacity;
  });
  var capacity = service.Capacity;
  return {
    mode: 'select-amount',
    old: old,
    capacity: capacity,
    max: old + capacity,
    initial: old,
    prices: service.ReservablePrices
  };
}

function selectPassengers(service, existingLines, passengerCount) {
  // Combine passenger arrays of all existing lines with passenger-wise boolean OR
  var empty = _.fill(new Array(passengerCount), false);
  var old = _.reduce(existingLines, function (acc, line) {
    return _.zipWith(acc, line.Passengers, function (a, b) {
      return a || b;
    });
  }, empty);

  return {
    mode: 'select-passengers',
    old: old,
    capacity: service.Capacity,
    initial: old.slice()
  };
}

function selectPrices(service, existingLines) {
  var old = totalExistingPriceQuantity(service, existingLines);
  return {
    mode: 'select-prices',
    prices: service.ReservablePrices,
    old: old,
    capacity: service.Capacity,
    initial: old.slice()
  };
}

function totalExistingPriceQuantity(service, existingLines) {
  var oldLists = _.map(existingLines, function (line) {
    return line.PriceQuantities;
  });
  return _.map(service.ReservablePrices, function (price) {
    return _.sumBy(oldLists, function (list) {
      return list[price.Index - 1].Quantity;
    });
  });
}

WinresOmalomaExtraServicesController.$inject = ['$rootScope', '$scope', 'omalomaService', '$q'];

_module3.default.component('winresOmalomaExtraServices', {
  template: require('./winresOmalomaExtraServices.html'),
  controller: WinresOmalomaExtraServicesController,
  require: {},
  bindings: {
    bookingNumber: '<',
    onChange: '&',
    onPassengersChange: '&' // NOTE: Passengers should probably be fetched somewhere else later
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaExtraServices/winresOmalomaExtraServices.js
// module id = 337
// module chunks = 2